import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Banco from './Banco';




interface BancoTableProps {
  data: Banco[];
  columns: TableColumn<Banco>[];
  customStyles: Record<string, any>;
}

const BancoTable: React.FC<BancoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Banco>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default BancoTable;